import React, { useState } from 'react';

import { PlusCircleFilled } from '@ant-design/icons';
import { Space, Input, Button, Row, Col, Modal } from 'antd';

import stringres from '../../translations/stringres';
import MenuMain from '../MainMenu';
import ClienteAddEdit from './ClienteAddEdit';
import ClientiGrid from './ClientiGrid';

const { Search } = Input;

export default function Clienti() {
    const [refresh, SetRefresh] = useState(false);
    const [isModalOpen, SetisModalOpen] = useState(false);
    const [ragioneSociale, SetRagioneSociale] = useState('');
    const onSearch = (value) => {
        SetRagioneSociale(value);
        SetRefresh(!refresh);
    };

    function onClickNew() {
        SetisModalOpen(true);
    }
    function onCancel() {
        SetisModalOpen(false);
    }

    return (
        <div>
            <MenuMain currentMenu="clienti"></MenuMain>

            <Row align={'middle'} justify={'start'} className="Space-horizontal">
                <Col className="Col-Separator">
                    <label className="App-title">{stringres.t('elencoClienti')}</label>
                </Col>
                <Col className="Col-Separator">
                    <Button icon={<PlusCircleFilled />} onClick={onClickNew} type="primary">
                        {stringres.t('nuovo')}
                    </Button>
                </Col>
                <Col className="Col-Separator" span={8}>
                    <Search
                        placeholder={stringres.t('campodiricercaclienti')}
                        allowClear
                        enterButton={stringres.t('ricerca')}
                        size="large"
                        onSearch={onSearch}
                    />
                </Col>
            </Row>

            <div style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                <hr></hr>
            </div>
            <Space className="App-body" direction="vertical">
                <ClientiGrid ragioneSociale={ragioneSociale} refresh={refresh}></ClientiGrid>
            </Space>
            <Modal
                title={stringres.t('elencodaticliente')}
                bodyStyle={{ marginTop: '20px' }}
                width={'50%'}
                open={isModalOpen}
                footer={null}
                onCancel={onCancel}
            >
                <ClienteAddEdit onCancel={onCancel}></ClienteAddEdit>
            </Modal>
        </div>
    );
}
